/** Represents the order index step of an option. */
export const optionOrderIndexStep = Math.pow(2, 24);
